import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { Task } from '../types';

interface TaskDependencyDisplayProps {
  task: Task;
  label?: string;
  /** When true, show "—" if empty (for table cells). When false, render nothing if empty. */
  emptyPlaceholder?: boolean;
  showLabel?: boolean;
}

const TaskDependencyDisplay: React.FC<TaskDependencyDisplayProps> = ({
  task,
  label = 'Depends on',
  emptyPlaceholder = false,
  showLabel = true,
}) => {
  const deps = task.dependsOn || [];
  if (deps.length === 0) {
    return emptyPlaceholder ? <Text fontSize="sm" color="gray.400">—</Text> : null;
  }

  return (
    <Box>
      {showLabel && (
        <Text fontSize="xs" color="gray.600" fontWeight="medium" mb={1}>
          {label}
        </Text>
      )}
      <VStack align="stretch" gap={0.5}>
        {deps.map((d) => (
          <Text key={d._id} fontSize="sm" color="gray.700" wordBreak="break-word">
            {d.title}
          </Text>
        ))}
      </VStack>
    </Box>
  );
};

export default TaskDependencyDisplay;
